import _count from './_count.js';

const count = (k) => _count(1n, k);
export default count;
